import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

import { DivListVideo, DivListItem, ImgVideo, VideoListDetails } from './List.styled';
import useVideo from '../../../store/video/useVideo';

const List = ({ videos, getVideoPath }) => {
  const { setCurrentVideo } = useVideo();
  const { push } = useHistory();

  const handleOnClick = (video) => {
    setCurrentVideo(video);
    push(getVideoPath(video));
  };

  return (
    <DivListVideo>
      {videos.map((video) => (
        <Fragment key={video.etag}>
          <DivListItem onClick={() => handleOnClick(video)}>
            <ImgVideo src={video.image} alt="image" />
            <VideoListDetails>
              <Typography>{video.title}</Typography>
            </VideoListDetails>
          </DivListItem>
          <Divider />
        </Fragment>
      ))}
    </DivListVideo>
  );
};

List.propTypes = {
  videos: PropTypes.array.isRequired,
  getVideoPath: PropTypes.func.isRequired,
};

export default List;
